import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';

const baseUrl = `${environment.apiBaseUrl}platform/datasources`;
const headers = new HttpHeaders({
  'x-no-notification': 'true'
});

@Injectable({
  providedIn: SharedModule
})
export class DatasourceService {

  constructor(private http: HttpClient) { }

  getDatasource(id: string): Observable<DataSource.DataSourceModel> {
    return this.http.get<DataSource.DataSourceModel>(`${baseUrl}/${id}`);
  }

  addDataSource(data: DataSource.DataSourceModel): Observable<DataSource.DataSourceModel> {
    return this.http.post<DataSource.DataSourceModel>(`${baseUrl}`, data, {headers});
  }

  editDataSource(dataSource): Observable<DataSource.DataSourceModel> {
    return this.http.put<DataSource.DataSourceModel>(`${baseUrl}/${dataSource.id}`, dataSource, {headers});
  }

  deleteDataSource(id: string) {
    return this.http.delete<any>(`${baseUrl}/${id}`);
  }

  testDatasource(data: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/test-connection`, data, {headers});
  }

  getFields(
    {
      datasourceId,
      affect,
      project,
      stepKey
    }: {
      datasourceId: string,
      affect?: string,
      project?: string,
      stepKey?: string
    }): Observable<any> {
    let params = new HttpParams();


    if (affect) {
      params = params.set('affect', affect);
    }

    if (project) {
      params = params.set('project', project);
    }

    if(stepKey === 'Fortify' && affect === 'projectVersions'){
      params = params.set('affect','projectVersions')
    }
    return this.http.get<any>(`${baseUrl}/${datasourceId}/fields`, {params});
  }

  createGithubAuthRequest(data: any): Observable<any> {
    return this.http.post<any>(`${baseUrl}/github`, data, {headers});
  }
}
